import "./src/styles/global.css";
import "@fontsource/inter/latin.css";
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import React from "react";
import { SearchProvider } from "./src/context/SearchContext";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <SearchProvider>{element}</SearchProvider>;
};